import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, type RecordRow } from "../api";
import { CommandBar } from "../Shell";
import { Icon } from "../icons";
import { ErrorBox, FLOWS, RecordGrid, label } from "../ui";

export function Records({ type }: { type: "issue" | "capa" }) {
  const [params, setParams] = useSearchParams();
  const state = params.get("state") ?? "";
  const [q, setQ] = useState(params.get("q") ?? "");
  const [rows, setRows] = useState<RecordRow[] | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [tick, setTick] = useState(0);
  const tabs = [...FLOWS[type].map((s) => s.id), ...(type === "issue" ? ["escalated"] : ["cancelled"])];

  useEffect(() => { setQ(params.get("q") ?? ""); }, [params]);
  useEffect(() => {
    setRows(null); setError(null);
    const term = q.trim();
    const t = setTimeout(() => {
      (term ? api.search(term).then((r) => r.filter((x) => x.type === type && (!state || x.state === state))) : api.records(type, state || undefined))
        .then(setRows, setError);
    }, term ? 250 : 0);
    return () => clearTimeout(t);
  }, [type, state, q, tick]);

  const setState = (s: string) => { const p = new URLSearchParams(params); s ? p.set("state", s) : p.delete("state"); setParams(p); };

  return (
    <>
      <CommandBar status={rows ? `${rows.length} record${rows.length === 1 ? "" : "s"}` : "Loading…"}>
        {type === "issue" ? <Link className="cmd primary" to="/new"><Icon name="plus" size={14} />Raise issue</Link> : <span className="cmd" style={{ color: "var(--fg-3)", cursor: "default" }}>CAPAs are opened by escalating an issue</span>}
        <button className="cmd" onClick={() => setTick((t) => t + 1)}>Refresh</button>
        <Link className="cmd" to="/pareto">Pareto</Link>
      </CommandBar>
      <div className="page">
        <div className="page-title">
          <h1>{type === "issue" ? "Issues" : "Corrective and preventive actions"}</h1>
          <span className="sub">{state ? label(state) : "All"}{q ? ` · matching “${q}”` : ""}</span>
        </div>
        <div className="pivot" role="tablist">
          <button role="tab" aria-selected={state === ""} onClick={() => setState("")}>All</button>
          {tabs.map((s) => <button key={s} role="tab" aria-selected={state === s} onClick={() => setState(s)}>{label(s)}</button>)}
        </div>
        <div className="filters">
          <input className="input" style={{ maxWidth: 420 }} type="search" aria-label="Filter" placeholder="Filter by number, title, or a BC key like L-2291" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        <ErrorBox error={error} />
        <section className="card">
          <RecordGrid rows={rows} empty={q ? "No matches." : `No ${type === "issue" ? "issues" : "CAPAs"}${state ? ` in ${label(state).toLowerCase()}` : " yet"}.`} />
        </section>
      </div>
    </>
  );
}
